export default function TreeLegend({ pt_name, overlap_level }) {
  const legends = [
    { name: `Index patient (${pt_name})`, color: "darkRed"},
    {
      name: `${overlap_level[0].toUpperCase() + overlap_level.slice(1)} level overlap found`,
      color: "purple",
    },
    { name: "No overlap found", color: "black" },
    { name: "No patient data", color: "grey" },
  ];

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        flexWrap: "wrap",
        paddingLeft: "45px",
        fontSize: 12,
      }}
    >
      {legends.map((legend, index) => (
        <div
          key={index}
          style={{ display: "flex", alignItems: "center", marginRight: "20px" }}
        >
          <span
            style={{
              display: "inline-block",
              width: "7px",
              height: "7px",
              borderRadius: "50%",
              backgroundColor: legend.color,
              marginRight: "10px",
            }}
          ></span>
          <span style={{ color: legend.color }}>{legend.name}</span>
        </div>
      ))}
    </div>
  );
}
